import { Observable } from 'rxjs';

import { PagerInfo } from '../model/pager-info';
import { Page } from '../model/page';
import { Option } from '../model/option';

export class PagerService {

    getPager(data: any[], currentPage: number, pageSize: number): PagerInfo {
        let pagerInfo = new PagerInfo();
        pagerInfo.totalItems = data !== undefined && data !== null ? data.length : 0;
        pagerInfo.currentPage = currentPage;
        pagerInfo.pageSize = pageSize - 1;
        pagerInfo.startIndex = (currentPage - 1) * (pageSize - 1);
        pagerInfo.endIndex = Math.min((pagerInfo.startIndex + pageSize - 1), (pagerInfo.totalItems - 1));
        pagerInfo.totalPages = Math.ceil(pagerInfo.totalItems / (pageSize - 1));
        pagerInfo.pages = this.getPages(data, pagerInfo);
        return pagerInfo;
    }

    /// Returns an array of Pages to page out the data that will be displayed
    getPages(data: Option[], pagerInfo: PagerInfo): Page[] {
        let pages = new Array<Page>();
        if (data !== undefined && data !== null && data.length > 1
            && pagerInfo !== undefined && pagerInfo !== null) {
            for (let i = 0; i < pagerInfo.totalPages; i++) {
                let page = new Page();
                let startIndex = i * pagerInfo.pageSize;
                let endIndex = Math.min((startIndex + pagerInfo.pageSize), (pagerInfo.totalItems - 1));

                page.PageNumber = i + 1;
                if (page.PageNumber === pagerInfo.totalPages) {
                    page.Data = data.slice(startIndex, (endIndex + 1));
                } else {
                    page.Data = data.slice(startIndex, endIndex);
                }
                pages.push(page);
            }
        }
        /// A single item in the list doesn't work very well'
        if (data !== undefined && data !== null && data.length === 1
            && pagerInfo !== undefined && pagerInfo !== null) {
            let page = new Page();
            let startIndex = pagerInfo.pageSize;
            let endIndex = Math.min((startIndex + pagerInfo.pageSize), (pagerInfo.totalItems - 1));

            page.PageNumber = 1;
            page.Data = data;
            pages.push(page);
        }
        return pages;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/pager.service.ts